import React from 'react'
import PropTypes from 'prop-types'

import { Tooltip } from 'Components/UI'

import {
  Timeslots as TimeslotsWrapper,
  DatePickerIcon,
  TimeslotLabel,
  TimeslotSeperator,
} from './styles'

const Timeslots = ({ times, date }) => {
  const timeslot = time => {
    if (!time.timeslot_end) {
      return `${time.timeslot_start}`
    }

    return `${time.timeslot_start} - ${time.timeslot_end}`
  }

  return (
    <TimeslotsWrapper>
      {times.map(time => {
        const labels = [date]

        if (time.is_option) {
          labels.push(time.service_name)
        }

        if (time.schedule_name) {
          labels.push(time.schedule_name)
        }

        if (time.timeslot_start) {
          labels.push(timeslot(time))
        }

        return (
          <TimeslotLabel key={time.schedule_id}>
            <DatePickerIcon size={18} />
            <Tooltip text={time.timezone} underlined>
              {labels.map((label, index) => (
                <span className="timeslot-label" key={label}>
                  {label}
                  {index < labels.length - 1 && <TimeslotSeperator />}
                </span>
              ))}
            </Tooltip>
          </TimeslotLabel>
        )
      })}
    </TimeslotsWrapper>
  )
}

Timeslots.defaultProps = {
  times: [],
}

Timeslots.propTypes = {
  date: PropTypes.string.isRequired,
  times: PropTypes.array,
}

export default Timeslots
